import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { IndentPOHeaderData, IndentPOHeader } from '../../../interfaces/pharmacy/IndentPOHeader';
import { IndentPOApi } from '../api/IndentPO.api';

@Injectable() 
export class IndentPOService extends IndentPOHeaderData{
 
  constructor(private api: IndentPOApi) {
    super();
  } 
  
  getall(url: string): Observable<IndentPOHeader[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<IndentPOHeader>{
      return this.api.getby_id(url);
  }

  create(url: string, data:IndentPOHeader): Observable<IndentPOHeader[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:IndentPOHeader): Observable<IndentPOHeader> { 
    return this.api.update(url,data);
  }  
  updates(url: string, data:any): Observable<any> { 
    return this.api.updates(url,data);
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
